export default __webpack_public_path__ + "static/media/datapoints.121193b7.svg";